/* eslint-disable
    no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
angular.module('unergie.main')
.controller('navigationErrorsCtrl', ($timeout, $rootScope, $scope, $state, AlertManager, ErrorCatcher, NavErrorsGraphDailyService, NavigationErrors, NgTableParams) => {
    $scope.idAccount = localStorage.navErrorsGraphIdAccount || ''
    $scope.byCode = localStorage.navErrorsGraphByCode ? (localStorage.navErrorsGraphByCode === 'true') || false : undefined
    $scope.startDate = Number(localStorage.navErrorsGraphStartDate) || moment().add(-3, 'month').startOf('day').unix()
    $scope.endDate = moment().add(1, 'day').endOf('day').unix()

    $scope.sliderOptions = {
        floor: moment().add(-120, 'days').unix(),
        ceil: $scope.endDate,
        step: 86400,
        enforceStep: true,
        showTicks: false,
        showTicksValues: false,
        translate(value) {
            return moment.unix(value).format('DD MMM YY')
        },
    }

    $scope.$on('slideEnded', () => refresh())

    $scope.emptyIdAccount = function () {
        $scope.idAccount = ''
        return refresh()
    }

    const reloadWithDates = function (dateStart, dateEnd) {
        $scope.startDate = moment(dateStart).unix()
        $scope.endDate = moment(dateEnd).add(1, 'day').unix()
        return refresh()
    }

    const refreshGraph = function () {
        $scope.refreshing = true
        $scope.refreshingGraph = true
        return NavigationErrors.daily({ startDate: moment.unix($scope.startDate).format('YYYY-MM-DD'),
            endDate: moment.unix($scope.endDate).format('YYYY-MM-DD'),
            byCode: $scope.byCode,
            id_account: $scope.idAccount }).$promise.then((data) => NavErrorsGraphDailyService.display('#vis', data, reloadWithDates)).catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshingGraph = false
            return ($scope.refreshing = $scope.refreshingGraph || $scope.refreshingList)
        })
    }

    const refreshList = function () {
        $scope.refreshing = true
        $scope.refreshingList = true
        return NavigationErrors.list({
            startDate: moment.unix($scope.startDate).format('YYYY-MM-DD'),
            endDate: moment.unix($scope.endDate).format('YYYY-MM-DD'),
            id_account: $scope.idAccount,
        }).$promise.then((data) => {
            $scope.tableParams = new NgTableParams({
                page: ($scope.tableParams != null ? $scope.tableParams.page() : undefined) || 1,
                count: ($scope.tableParams != null ? $scope.tableParams.count() : undefined) || 25,
                filter: ($scope.tableParams != null ? $scope.tableParams.filter() : undefined) || {},
                sorting: ($scope.tableParams != null ? $scope.tableParams.sorting() : undefined) || {},
            }, { counts: [10, 25, 50, 100], dataset: data })
            return $scope.tableParams
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshingList = false
            return ($scope.refreshing = $scope.refreshingGraph || $scope.refreshingList)
        })
    }

    const refresh = function () {
        localStorage.navErrorsGraphStartDate = $scope.startDate
        localStorage.navErrorsGraphByCode = $scope.byCode
        localStorage.navErrorsGraphIdAccount = $scope.idAccount
        refreshGraph()
        return refreshList()
    }

    $scope.refresh = refresh
    refresh()

    $scope.reRenderSlider = () => $timeout(() => $rootScope.$broadcast('rzSliderForceRender'))


    return $scope.reRenderSlider()
})
